import { Consumer as C, createContext } from 'react';
import State from '../../core/State';

export const context = createContext<State>({} as State);

export const Provider = context.Provider;
export const Consumer = context.Consumer as C<State>;
